import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Clock } from "lucide-react";
import { OWNER, whatsappLink } from "@/lib/legalContent";
import { useCookieConsent } from "@/context/CookieConsentContext";
import { LEGAL } from "@/constants/testIds";

export default function Footer() {
  const { openPreferences } = useCookieConsent();
  const year = new Date().getFullYear();

  return (
    <footer className="bg-[#2a1233] text-white/80">
      <div className="mx-auto max-w-7xl px-5 py-14 lg:px-8">
        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-center gap-3">
              <span className="grid h-11 w-11 place-items-center rounded-xl bg-primary font-display text-2xl font-semibold text-white">
                L
              </span>
              <span className="leading-tight">
                <span className="block font-display text-xl font-semibold text-white">Lorena Cuevas</span>
                <span className="block text-[10px] font-semibold uppercase tracking-[0.22em] text-primary/90">
                  Clínica Podológica
                </span>
              </span>
            </div>
            <p className="mt-5 text-sm leading-relaxed text-white/60">
              Cuidamos la salud de tus pies en El Viso del Alcor con tratamientos personalizados y un trato cercano.
            </p>
          </div>

          <div>
            <h4 className="font-display text-lg font-semibold text-white">Contacto</h4>
            <ul className="mt-4 space-y-3 text-sm">
              <li className="flex gap-3">
                <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-primary" />
                <span>{OWNER.addressShort}, {OWNER.city}</span>
              </li>
              <li className="flex gap-3">
                <Phone className="mt-0.5 h-4 w-4 shrink-0 text-primary" />
                <a href={`tel:${OWNER.phoneBookingRaw}`} className="hover:text-white">{OWNER.phoneBooking}</a>
              </li>
              <li className="flex gap-3">
                <Mail className="mt-0.5 h-4 w-4 shrink-0 text-primary" />
                <a href={`mailto:${OWNER.email}`} className="break-all hover:text-white">{OWNER.email}</a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-display text-lg font-semibold text-white">Horario</h4>
            <ul className="mt-4 space-y-3 text-sm text-white/70">
              <li className="flex gap-3"><Clock className="mt-0.5 h-4 w-4 shrink-0 text-primary" /><span>Lun – Vie: 09:00–14:00 / 16:00–20:30</span></li>
              <li className="pl-7">Mañanas y tardes</li>
              <li className="pl-7">Sábado y domingo: Cerrado</li>
            </ul>
            <a
              href={whatsappLink()}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-5 inline-block rounded-full bg-primary px-5 py-2.5 text-sm font-bold text-white transition-transform hover:-translate-y-0.5"
            >
              Reservar por WhatsApp
            </a>
          </div>

          <div>
            <h4 className="font-display text-lg font-semibold text-white">Legal</h4>
            <ul className="mt-4 space-y-3 text-sm">
              <li>
                <Link to="/aviso-legal" data-testid={LEGAL.footerAvisoLink} className="text-white/70 transition-colors hover:text-primary">
                  Aviso Legal
                </Link>
              </li>
              <li>
                <Link to="/politica-de-privacidad" data-testid={LEGAL.footerPrivacidadLink} className="text-white/70 transition-colors hover:text-primary">
                  Política de Privacidad
                </Link>
              </li>
              <li>
                <Link to="/politica-de-cookies" data-testid={LEGAL.footerCookiesLink} className="text-white/70 transition-colors hover:text-primary">
                  Política de Cookies
                </Link>
              </li>
              <li>
                <button
                  onClick={openPreferences}
                  data-testid={LEGAL.footerConfigCookies}
                  className="text-left text-white/70 transition-colors hover:text-primary"
                >
                  Configurar Cookies
                </button>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-4 border-t border-white/10 pt-6 text-xs text-white/50 md:flex-row">
          <p>© {year} {OWNER.name}. Todos los derechos reservados.</p>
          <p>NIF {OWNER.nif} · El Viso del Alcor (Sevilla)</p>
        </div>
      </div>
    </footer>
  );
}
